import * as Sentry from '@sentry/browser'

export async function fileUpload(signedUrl, image, onUploadProgress) {
  try {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest()
      xhr.open("PUT", signedUrl)
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          resolve(xhr.response)
        }
      })
      if (onUploadProgress) {
        xhr.upload.onprogress = (e) => {
          let percentComplete = 0
          percentComplete = Math.ceil((e.loaded / e.total) * 100)
          onUploadProgress(percentComplete)
        }
      }
      xhr.setRequestHeader('Content-Type', image.type)
      xhr.send(image)
    })
  }
  catch (e) {
    Sentry.captureException(e)
    console.error(e)
  }
}
